import { addToPool, countByDifficulty } from './offlineDb';

/** Her zorlukta hedeflenen bulmaca sayısı (toplam 5*3 = 15) — tek bir global
 * sayaç yerine zorluk başına hedef, havuzun bir zorlukla tıkanıp diğerlerinin
 * hiç dolmamasını engeller. */
export const OFFLINE_POOL_TARGET_PER_DIFFICULTY = 3;

const API = import.meta.env.VITE_API_URL || 'http://localhost:8000';

let _refilling = false;

async function fetchPuzzle(difficulty: number, token: string | null) {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${API}/game/offline-pack`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ count: 1, difficulty }),
  });
  if (!res.ok) return null;
  const data = await res.json();
  return (data.puzzles || [])[0] ?? null;
}

export async function refillPoolIfNeeded(token: string | null, ownerUserId: string | null): Promise<void> {
  if (_refilling) return;
  if (typeof navigator !== 'undefined' && !navigator.onLine) return;
  _refilling = true;
  try {
    const counts = await countByDifficulty(ownerUserId);
    for (const diffStr of Object.keys(counts)) {
      const difficulty = Number(diffStr);
      while (counts[difficulty] < OFFLINE_POOL_TARGET_PER_DIFFICULTY) {
        if (typeof navigator !== 'undefined' && !navigator.onLine) return;
        const puzzle = await fetchPuzzle(difficulty, token);
        if (!puzzle) break; // sunucu bu zorlukta üretemedi — bir sonraki zorluğa geç
        await addToPool([puzzle]);
        counts[difficulty]++;
      }
    }
  } catch {
    // Offline / network hatası — sessizce çık
  } finally {
    _refilling = false;
  }
}
